import axios from "axios";
import { API_URL } from "env";
import {
  clearDataFromLocalStorage,
  getDataFromLocalStorage,
} from "utils/localStore.utils";

export const BASE_URL = API_URL;

export const getApiRequestHeader = () => {
  /**Will get token from reducers */
  const authtoken = getDataFromLocalStorage("token");
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: authtoken ? `Bearer ${authtoken}` : "",
  };
};

let instance = axios.create({
  baseURL: BASE_URL,
  timeout: 60000,
}) as any;

let isLoggingOut = false;

const logoutOnUnauthorized = () => {
  if (isLoggingOut || !getDataFromLocalStorage("token")) return;
  isLoggingOut = true;
  clearDataFromLocalStorage("token");
  clearDataFromLocalStorage("user");
  clearDataFromLocalStorage("lastInteractionTime");
  window.location.assign("/login");
};

const isUnauthorized = (status: unknown, bodyStatus: unknown) =>
  status === 401 || bodyStatus === 401;

instance.interceptors.response.use(
  (response: any) => {
    if (isUnauthorized(response?.status, response?.data?.status)) {
      logoutOnUnauthorized();
    }
    return response;
  },
  (error: any) => {
    if (
      isUnauthorized(error?.response?.status, error?.response?.data?.status)
    ) {
      logoutOnUnauthorized();
    }
    return Promise.reject(error);
  }
);

export const updateHeaders = () => {
  const header = getApiRequestHeader();
  instance.defaults.headers = header as any;
};

export const old_request = async ({ method, url, data, headers }: any) => {
  if (headers === undefined) {
    updateHeaders();
  }
  const promise = instance[method](url, data);
  let response;
  try {
    response = await promise;
  } catch (error: any) {
    return error.response?.data;
  }
  return response?.data;
};

export const request = async ({ method, url, data, headers }: any) => {
  if (headers === undefined) {
    updateHeaders();
  }
  const requestConfig = {
    method,
    url,
    headers,
    data, // Set the data property for DELETE requests with a payload
  };
  const promise = instance(requestConfig);

  let response;
  try {
    response = await promise;
  } catch (error: any) {
    return error.response?.data;
  }

  return response?.data;
};

export const get = (url: string, permission_name: string, config: any) => {
  return request({
    method: "get",
    url,
    data: {},
    ...config,
  });
};

export const post = (
  url: string,
  data: any,
  permission_name: string,
  config: any
) => {
  return request({
    method: "post",
    url,
    data,
    ...config,
  });
};

export const patch = (
  url: string,
  data: any,
  permission_name: string,
  config: any
) => {
  return request({
    method: "patch",
    url,
    data,
    ...config,
  });
};

export const del = (
  url: string,
  data: any,
  permission_name: string,
  config: any
) => {
  return request({
    method: "delete",
    url,
    data,
    ...config,
  });
};
